import { StyleTwoPinHomeBold } from '@ha/icons';
import React from 'react';
import { Coords } from 'google-map-react';

import { Box } from '@hbf/dsl';

interface Props {
  lat: Coords['lat'];
  lng: Coords['lng'];
}

const MarkerSize = { width: 60, height: 60 };

const ListingMapMarker: React.FC<Props> = () => (
  <Box
    position="absolute"
    width={MarkerSize.width}
    height={MarkerSize.height}
    top={`-${MarkerSize.height}px`}
    left={`-${MarkerSize.width / 2}px`}
    fontSize="3rem"
  >
    <StyleTwoPinHomeBold fontSize="inherit" color="secondary" />
  </Box>
);

export { ListingMapMarker };
